module.exports = __webpack_public_path__ + "static/media/studio-etc17.f5d33368.png";